export enum BigTabBorderStyle {
  NONE = 'NONE',
  FOLIO = 'FOLIO',
  TABBED_FOLIO = 'TABBED_FOLIO',
  TABS = 'TABS',
  DATABOXES = 'DATABOXES',
}
